import React, { useState, useRef, useEffect } from "react";
import MSelect from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import propTypes from "prop-types";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";

const useStyles = makeStyles(theme => ({
  formControl: {
    // margin: theme.spacing(1),
    minWidth: 120,
    width: "100%"
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  },
  select: {
    width: "100%"
  }
}));

export const Select = ({
  label = "",
  items = [],
  selectHandler = () => {}
}) => {
  const classes = useStyles();
  const [current, setCurrent] = useState("");
  const [labelWidth, setLabelWidth] = useState(0);
  const inputLabel = useRef(null);
  useEffect(() => {
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);

  return (
    <div>
      <FormControl variant="outlined" className={classes.formControl}>
        <InputLabel ref={inputLabel} id={`select-${label}-label`}>
          {label}
        </InputLabel>
        <MSelect
          className={classes.select}
          labelId={`select-${label}-label`}
          id={`select-${label}`}
          onChange={e => {
            if (e) {
              setCurrent(e.target.value);
              selectHandler(e.target.value);
            } else {
              setCurrent("");
              selectHandler("");
            }
          }}
          value={current}
          labelWidth={labelWidth}
        >
          {items.map(el => (
            <MenuItem key={el._id} value={el._id}>
              {el.label}
            </MenuItem>
          ))}
        </MSelect>
      </FormControl>
    </div>
  );
};

Select.propTypes = {
  items: propTypes.array,
  label: propTypes.string,
  selectHandler: propTypes.func
};

export default Select;
